<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <a-form-item label="姓名">
                <a-input style="min-width: 200px" v-model="search.name" placeholder="请输入姓名关键词"></a-input>
            </a-form-item>
            <a-form-item label="电话">
                <a-input style="min-width: 200px" v-model="search.mobile" placeholder="请输入电话关键词"></a-input>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page" style="overflow: auto;">
            <div class="list">
                <div class="statistics">共{{ amount }}条</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">

                    <template slot="weixin" slot-scope="text, record">
                        <div class="weixin-zhanshi">
                            <img class="weixin-headimg-radio" style="width: 40px;" :src="record.headimgurl" alt="">
                            {{ record.nickname }}
                        </div>
                    </template>
                    
                    <template slot="jilu_amount" slot-scope="text, record">
                        <a-tag style="cursor: pointer;" @click="toUrl('/chicun/list?who=' + record.who)">{{ record.jilu_amount }}</a-tag>
                    </template>
                    <template slot="jilu_max_amount" slot-scope="text, record">
                        <a-tag style="cursor: pointer;" @click="toUrl('/chicun/list?who=' + record.who + '&isMax=1')">{{ record.jilu_max_amount }}</a-tag>
                    </template>
                    
                    <template slot="jilu_status" slot-scope="text, record">
                        <span v-if="record.jilu_status == 0">已禁用</span>
                        <span v-if="record.jilu_status == 1">正常</span>
                    </template>
                    <template slot="caozuo" slot-scope="text, record">

                        <a-popconfirm v-if="record.jilu_status == 1" title="确定要禁用吗" @confirm="changeStatus(record.id, 0)"
                            okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger" size="small">
                                禁用
                            </a-button>
                        </a-popconfirm>

                        <a-popconfirm v-if="record.jilu_status == 0" title="确定要恢复吗"
                            @confirm="changeStatus(record.id, 1)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="primary" size="small">
                                恢复
                            </a-button>
                        </a-popconfirm>
                    </template>
                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>

    </div>
</template>
  
<style lang='scss' scoped></style>
  
<script>
import moment from 'moment'
export default {
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "编号",
                    dataIndex: "id",
                    align: 'center'
                },
                {
                    title: "姓名",
                    dataIndex: "name",
                    align: 'center'
                },

                {
                    title: "微信",
                    align: 'center',
                    scopedSlots: {
                        customRender: "weixin",
                    },

                },
                {
                    title: "电话",
                    align: 'center',
                    dataIndex: "tel",
                },

                {
                    title: "Email",
                    align: 'center',
                    dataIndex: "email",
                },

                {
                    title: "记录数量",
                    align: 'center',
                    scopedSlots: {
                        customRender: "jilu_amount",
                    },
                },

                {
                    title: "最大记录数量",
                    align: 'center',
                    scopedSlots: {
                        customRender: "jilu_max_amount",
                    },
                },

                {
                    title: "注册时间",
                    align: 'center',
                    dataIndex: "jilu_time",
                },

                {
                    title: "状态",
                    align: 'center',
                    dataIndex: "jilu_status",
                    scopedSlots: {
                        customRender: "jilu_status",
                    },
                },
                {
                    title: "操作",
                    align: 'center',
                    dataIndex: "caozuo",
                    scopedSlots: {
                        customRender: "caozuo",
                    },
                },
            ],
            search: {
                name: "",
                mobile: "",
                now_page: 1
            },
            amount: 0,
            pages: 1,
            list: [],
        };
    },
    watch: {

    },
    async created() {
        this.getList();
    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const r = await this.$axios.post("/chicun/getUserList", this.search );
            this.list = r.data.list;
            this.amount = r.data.amount;
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        },
        async changeStatus(id, status) {
            const r = await this.$axios.post("/chicun/changeStatus", {
                id: id,
                status: status,
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getList();
            } else {
                this.$message.error('操作失败...')
            }
        },
        toUrl (url) {
            this.$router.push(url)
        }
    },
};
</script>
  
<style></style>
